
<div class="relative min-h-screen lg:flex bg-slate-100 text-slate-800">
  <app-sidebar [isOpen]="isMobileMenuOpen()" (closeMenu)="isMobileMenuOpen.set(false)"></app-sidebar>
  
  <div class="flex-1 flex flex-col min-w-0">
    <header class="bg-white shadow-sm p-2 sm:p-3 z-10 flex justify-between items-center flex-shrink-0 border-b border-gray-200 sticky top-0">
        <!-- LEFT GROUP -->
        <div class="flex items-center gap-2 sm:gap-4 flex-shrink min-w-0">
          <button (click)="isMobileMenuOpen.set(true)" class="lg:hidden text-gray-600 hover:text-gray-900 p-1 rounded-md hover:bg-gray-100">
            <i class="fa-solid fa-bars text-xl"></i>
          </button>
          
          <div class="flex items-center gap-2 text-lg sm:text-xl font-bold text-gray-800 whitespace-nowrap overflow-hidden">
            <i class="fa-solid fa-cannabis text-emerald-500 flex-shrink-0"></i>
            <span class="hidden xs:inline truncate font-brand tracking-wide">CHUAMKAN</span>
          </div>

          <!-- Data Source Indicator (Tablet+) -->
          <div class="hidden md:block">
             <app-data-source-indicator [isFirebaseMode]="isSupabaseMode()"></app-data-source-indicator>
          </div>

          <!-- Portal Buttons (Icon on Mobile, Text on Large Screens) -->
           @if (isOwner()) {
            <a routerLink="/portal" rel="noopener noreferrer"
              class="p-2 sm:px-4 sm:py-2 rounded-md transition-colors text-sm font-bold flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white"
              [title]="'pos.header.customerPortal' | translate">
                <i class="fa-solid fa-users"></i>
                <span class="hidden lg:inline">{{ 'pos.header.customerPortal' | translate }}</span>
            </a>
          }
          @if (isAdmin()) {
            <a routerLink="/portal" rel="noopener noreferrer"
              class="p-2 sm:px-4 sm:py-2 rounded-md transition-colors text-sm font-bold flex items-center gap-2 bg-purple-600 hover:bg-purple-500 text-white"
              [title]="'pos.header.previewPortal' | translate">
                <i class="fa-solid fa-eye"></i>
                <span class="hidden lg:inline">{{ 'pos.header.previewPortal' | translate }}</span>
            </a>
          }
        </div>

        <!-- RIGHT GROUP -->
        @if (currentUser(); as user) {
          <div class="flex items-center gap-2 sm:gap-4 flex-shrink-0 ml-2">
            
            <!-- TOUR BUTTON -->
            <button (click)="startTour()" class="p-2 rounded-full hover:bg-slate-100 text-slate-500 hover:text-emerald-600 transition-colors" title="แนะนำการใช้งาน (Tour)">
                <i class="fa-solid fa-circle-question text-xl"></i>
            </button>

            <app-language-switcher></app-language-switcher>
            
            <!-- User Info (Desktop only) -->
            <div class="text-right hidden md:block leading-tight">
              <span class="font-semibold block text-sm">{{ user.name }}</span>
              <p class="text-[10px] text-gray-500 capitalize">{{ user.role }}</p>
            </div>
            
            <!-- Logout Button (Icon on Mobile) -->
            <button (click)="requestLogout()" class="p-2 sm:px-4 sm:py-2 rounded-md transition-colors text-sm font-semibold flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-700" [title]="'backOffice.header.logout' | translate">
              <i class="fa-solid fa-right-from-bracket"></i>
              <span class="hidden sm:inline">{{ 'backOffice.header.logout' | translate }}</span>
            </button>
          </div>
        }
      </header>
    <main class="flex-1 p-4 sm:p-6 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<app-confirmation-modal
  [isOpen]="showLogoutConfirm()"
  [title]="'backOffice.logoutConfirm.title' | translate"
  [message]="'backOffice.logoutConfirm.message' | translate"
  [confirmButtonText]="'backOffice.logoutConfirm.confirmButton' | translate"
  confirmButtonClass="bg-red-600 hover:bg-red-700"
  (confirm)="handleConfirmLogout()"
  (cancel)="handleCancelLogout()"
></app-confirmation-modal>
